var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75V13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7058 3.74999L2.45585 18C2.32442 18.2276 2.25512 18.4858 2.25488 18.7487C2.25465 19.0115 2.3235 19.2698 2.45452 19.4977C2.58555 19.7256 2.77416 19.915 3.00145 20.0471C3.22875 20.1791 3.48674 20.2491 3.7496 20.25H20.2496C20.5125 20.2491 20.7705 20.1791 20.9977 20.0471C21.225 19.915 21.4136 19.7256 21.5447 19.4977C21.6757 19.2698 21.7445 19.0115 21.7443 18.7487C21.7441 18.4858 21.6748 18.2276 21.5434 18L13.2934 3.74999C13.1629 3.52206 12.9746 3.33263 12.7474 3.20088C12.5202 3.06914 12.2622 2.99976 11.9996 2.99976C11.737 2.99976 11.479 3.06914 11.2518 3.20088C11.0246 3.33263 10.8363 3.52206 10.7058 3.74999V3.74999Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.68efacda580c347c3a669ea1149440c5.svg";
export { ForwardRef as ReactComponent };